import { OnboardingStatus } from 'models/general';

export const onboardingStatusToTabMap = {
  [OnboardingStatus.PENDING]: 'pending',
  [OnboardingStatus.PROCESSING]: 'processing',
  [OnboardingStatus.INCOMPLETE]: 'incomplete',
  [OnboardingStatus.COMPLETED]: 'completed',
};
